(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  /* <product-recommendations>: loads this section from the recommendations endpoint once the
     page is idle (after `load`), so the carousel is in place before the shopper scrolls to it
     (no late layout shift of the USP strip / footer); stays hidden when Shopify returns no
     products. Boots on DOMContentLoaded: compiled section JS may run before global.js. */
  (function () {
    function boot() {
      if (!window.customElements || customElements.get('product-recommendations')) return;
      class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          if (this._ready || !this.dataset.url) return;
          this._ready = true;
          if (this.querySelector('.product-card')) return;
          const load = () => {
            fetch(this.dataset.url, { credentials: 'same-origin' })
              .then((r) => (r.ok ? r.text() : ''))
              .then((html) => {
                const fresh = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations') : null;
                if (fresh && fresh.querySelector('.product-card')) this.innerHTML = fresh.innerHTML;
                else this.hidden = true;
              })
              .catch(() => { this.hidden = true; });
          };
          const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
          const kick = () => idle(load, { timeout: 2000 });
          if (document.readyState === 'complete') kick();
          else window.addEventListener('load', kick, { once: true });
        }
      }
      customElements.define('product-recommendations', ProductRecommendations);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
